module.exports = __webpack_public_path__ + "img/4-5.5ef0e2c5.png";